import { jsx as _jsx } from "react/jsx-runtime";
import { CommandItem } from "@air/cmdk";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const ComboboxItem = /*#__PURE__*/ memo((param)=>{
    let { children, className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(CommandItem, {
        className: tailwindMerge("group/combobox-item flex min-h-[32px] cursor-pointer items-center gap-2 rounded-4 px-2 text-14 text-grey-12 outline-none data-[selected=true]:bg-grey-4 hover:bg-grey-4 active:bg-grey-5", className),
        "data-testid": "COMBOBOX_ITEM",
        ...restOfProps,
        children: children
    });
});
ComboboxItem.displayName = "ComboboxItem";
